<template>
  <div class="address-list">
    <div v-if="filteredAddresses.length === 0" class="no-addresses">
      <p>Keine Adressen gefunden</p>
    </div>
    <div v-else class="address-items">
      <div
        v-for="(address, index) in filteredAddresses"
        :key="index"
        class="address-item"
      >
        <div class="icon-box">
          <span class="material-icons">location_on</span>
        </div>
        <div class="address-info">
          <h3 class="address-name">{{ address.name }}</h3>
          <p class="address-street">{{ address.street }}</p>
          <p class="address-city">{{ address.city }}, {{ address.zip }}</p>
        </div>
        <button class="message-btn">
          <span class="material-icons">message</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    addresses: {
      type: Array,
      default: () => [],
    },
    searchQuery: {
      type: String,
      default: "",
    },
  },
  computed: {
    filteredAddresses() {
      return this.addresses.filter((address) => {
        const search = this.searchQuery.toLowerCase();
        return (
          address.name.toLowerCase().includes(search) ||
          address.street.toLowerCase().includes(search) ||
          address.city.toLowerCase().includes(search) ||
          address.zip.toLowerCase().includes(search)
        );
      });
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/icon?family=Material+Icons");

.address-list {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  background: transparent;
  margin-top: 20px;
  margin: 0 auto;
  width: 800px;
  margin-top: 10px;
  border-radius: 12px;
}

.no-addresses {
  text-align: center;
  color: #6b7280;
}

.address-items {
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 100%;
  max-width: 600px;
}

.address-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  padding: 15px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background: white;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.3s ease;
}

.address-item:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.icon-box {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f1f1f1;
  border-radius: 50%;
}

.icon-box .material-icons {
  font-size: 24px;
  color: #333;
}

.address-info {
  flex-grow: 1;
}

.address-name {
  font-size: 1rem;
  font-weight: bold;
  color: #111827;
}

.address-street,
.address-city {
  color: #4b5563;
  font-size: 0.875rem;
}

.message-btn {
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  border-radius: 50%;
}

.message-btn:hover {
  background: #f1f1f1;
}

.message-btn .material-icons {
  font-size: 24px;
  color: #333;
}
</style>
